import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import Lottie from "lottie-react";
import animationData from "./lottie/warning-light.json";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";

const ValidationExcelModal = ({ modal, setModal, title, description }) => {
  const { validationExcelErrors } = useSelector((state) => state.claim);

  const handleDownload = () => {
    if (validationExcelErrors.length === 0) {
      return;
    }
    // Extract only the 'message' field as an array of single-item arrays
    const messages = validationExcelErrors.map((error) => [
      error.message || "Unknown error",
    ]);
    const ws = XLSX.utils.aoa_to_sheet(messages);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Validation Errors");
    XLSX.writeFile(wb, "validation_errors.xlsx");
    setModal(false);
  };

  return (
    <Modal
      show={modal}
      onHide={() => setModal(false)}
      centered
      dialogClassName="wizard-modal"
    >
      <Modal.Header className="border-1 py-2 mb-4 pb-3 border-bottom pb-0">
        <h5 className="modal-title fs-9 fw-semibold">{title}</h5>
        <FalconCloseButton
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
          onClick={() => setModal(false)}
        />
      </Modal.Header>
      <Modal.Body className="pt-0">
        <Flex justifyContent="center" alignItems="center" direction="column">
          <Lottie
            animationData={animationData}
            loop={true}
            style={{ width: "100px", marginBottom: "1rem" }}
          />
          <p className="fs-10 text-center mb-3">{description}</p>
          {validationExcelErrors.length > 0 && (
            <Button variant="danger" onClick={handleDownload}>
              Download Validation Excel
            </Button>
          )}
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

ValidationExcelModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  setModal: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

ValidationExcelModal.defaultProps = {
  title: "Error",
  description: "An error occurred. Please try again.",
};

export default ValidationExcelModal;
